import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import jwt from 'jsonwebtoken'

Vue.use(Vuex)
// Vuex config

export const store = new Vuex.Store({
  state: {
    token: '',
  },
  mutations: {
    save_token (state, token) {
      state.token = token
    }
  },
  actions: {
    async createJWT (commit, user) {
      const secret =  "-----BEGIN PRIVATE KEY-----\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDvqU4DycSZdOnm\noblFC81cEzYld12jXtlGfyjoprHSxfElzxtHBQjtWIiPHLxuqaDREwVVJzWJfBw0\nXcI5UBcRPRC1bFl4lyF7Ls+qf3YFq4aIJUHhyTh5jgFoghFF48ktj2xMW+QAW81Y\nc054/Q2UfSPokaCOHmanBLmyfqfBYCtZuBkhJ3/nuKtOVFN0LHvY3kv9CwwxPHtQ\nGtXN4JX3JPQR2IvxUGlJP6BNziQHfuWT7zbWUBIN6M92+1cet16nDjds+jrf98WE\n6f3v3G0kxw2rh+d/Ex1uZDdoXgICNw9iQtZ0OuOjkQNg6sV9hP0cXN9zExkWo9tp\nyojza2V3AgMBAAECggEAEmvDq1be3aIMOHCbJPYl8BB/S5yZKJgpwIQVnjbx2W7i\n0jJ7uOxne0F1fZ/f0UGzMrQbkif+ssqaAGG/Lq3ml/9G7Cr1Kuey6HJN/p+SxWzM\nXQ/quHLBpyuFwC//KTgQ8TI3nhw8sipcO5LhUpC2HSu2jtxiqDR9/2hwPYquqkDr\n/oLhqFv/MpOnb4vsaOq2v2uYPybRi+7H6Pc2VqoiIhJ02p8WnNRUQTalPB34q9uy\njQMmz+5jWjy0nWWs8Vl88gpKcJCOpVq1A34Z6kABmiRTuzSin51E7ioV6nu3j6fH\nKrdZGWzcGZsbpGbNHZmxLzBoFBg7Sd2AJttwAluiQQKBgQD8YHQ7BymkaU6kIf2T\ndVj7SLRQPcFGvCcNkoin9fGMesBsnLKFvdPIPORlQvoNkE5iMVNvhupKhybMyamO\ncNGkEZwpZpcNR/MoHwzQjSJJLk4ZMJHz3pSvllhH44nz4Zdygc3dkccDXysNJVKQ\nZXSZuinH2T8Rsxkcqp6rJej0EwKBgQDzGh5RzsLK5awPabHj7wPDzw/67hcvs62P\nOijqDh5LIrcdw4z1MoYyLlxCFaSMJAdCkeMBBWjdcvgBnxvc6+kRaMMj1ZU5wujZ\nHmvgqaSIRmZccvJEc+mqp3HGoVci04udkCsN/JOUC+0UwAKmb/FHsUNkWSszU6VX\nH1g9UmgNjQKBgCECjLFb0nqKu5qER6KN6sGTVOJZ8XnLCmCgFffCF4IEXD7YkBEm\nLxk1vbnw9LvpcBcv1HX185cj7lNC3UagQwtusjpIDOHT014gEZEFpMJlqBlrXOvE\n5TXCOHHOtTCNBT4Y9FBSzPEH9Z2WkCIK4yFoVCarp7As+M/jETXZk4q5AoGBAKG5\nu3fzFDXE611plFWtuZR3WQs3f6dVYl5Jc9SZxd94XdfoMwsgLJSPsQKpwUkV4tqP\nkTQptCS2inURs4iaTPgu+LsLKPY/S4a9rUjNss6R/yD7u158unO0Z4Wb6gsaLuSI\nd4wbftZbxMIsJtcw25Q1Qj8s7wd7WyCFkr9g5iY1AoGBAJJj9JXXuvAjKoxY7tnv\nr2IT4wkJ23nXnWb288kftwp5v5enfzK//FvgtkCkz5SWAq4iDWrBqPqPJNjpGHpz\ns/bV/22VAUOaQTSFHCVzA+3abIy79KODXmWY77poCpZOT/rRDrI2z5SHrAQjCgWP\nOjalmMAFMAlLu+g0YMtDHJlz\n-----END PRIVATE KEY-----\n"
      const date = new Date()
      const seconds = Math.floor(date.getTime() / 1000)
      const expSeconds = seconds + 60 * 60
      const payload = {
        iss: "lovely-read-only@planilla-love.iam.gserviceaccount.com",
        scope: 'https://www.googleapis.com/auth/drive',
        aud: 'https://oauth2.googleapis.com/token',
        exp: expSeconds,
        iat: seconds
      }
      const token = jwt.sign(payload, secret, { algorithm: 'RS256' })
      const oAuthPayload = {
        grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
        assertion: token
      }
      await axios.post('https://oauth2.googleapis.com/token', oAuthPayload)
        .then((res) => {
          localStorage.setItem('gapi.access_token', res.data.access_token)
          commit.commit('save_token', res.data.access_token)
        })
        .catch((err) => { console.log(err) })
      return token
    }
  },
  getters: {
    getToken: state => state.token,
  }
})
